import { useSearchParams } from 'react-router-dom';

import { useFilteredTemplatesListQuery, WaypointTemplateType } from '@dashboard/generated/wp/platform';

export default function useCurrentTemplatesQuery() {
  const [params] = useSearchParams();

  const queryType = params.get('type');
  const type = queryType === 'LAYOUT' ? WaypointTemplateType.Layout : WaypointTemplateType.Template;
  return useFilteredTemplatesListQuery({ fetchPolicy: 'network-only', variables: { type } });
}
